import { render } from "./StockTransfers.vue?vue&type=template&id=c0581a62"
import script from "./StockTransfers.vue?vue&type=script&lang=js"
export * from "./StockTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__